<template>
  <UserLayout>
    <div class="px-12 lg:px-6 lg:ml-20 md:mt-16 mt-32 mb-4">
      <h3 class="uppercase py-4 mt-4 text-2xl font-bold">Trainer Posts</h3>
      <UserTrainerPostList
        :data="posts"
        :handlePostLike="handlePostLike"
        :statusCode="
          userFollowedTrainerPosts && userFollowedTrainerPosts.statusCode
        "
      />
      <Pagination
        v-if="posts.length"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
    </div>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import UserTrainerPostList from "@/components/UserTrainerPostList";

import { Pagination } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    UserLayout,
    Pagination,
    UserTrainerPostList,
  },
  data() {
    return {
      posts: [],
      currentPage: 1,
      totalPages: "",
    };
  },
  computed: {
    ...mapGetters(["userFollowedTrainerPosts"]),
    statePosts: function () {
      return this.userFollowedTrainerPosts;
    },
  },
  methods: {
    ...mapActions(["getUserFollowedTrainerPosts", "postCommentLike"]),

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      this.posts = [];
      await this.getUserFollowedTrainerPosts({ query });
    },
    async handlePostLike(id, isLiked) {
      let is_liked = "";
      let likeCounter = "";
      if (isLiked) {
        is_liked = 1;
        likeCounter = 1;
      } else {
        is_liked = null;
        likeCounter = -1;
      }
      const data = {
        is_liked: 1,
        post_id: id,
      };

      this.posts.map((item) => {
        if (item.id === id) {
          item.is_liked = is_liked;
          item.like_counter = item.like_counter + likeCounter;
        }
      });
      await this.postCommentLike(data);

      const query = {
        page: this.currentPage,
      };
      await this.getUserFollowedTrainerPosts({ query });
    },
  },

  async created() {
    const query = {
      page: this.currentPage,
    };
    if (this.getToken()) {
      await this.getUserFollowedTrainerPosts({ query });
    }
  },
  watch: {
    statePosts: function () {
      this.posts = this.userFollowedTrainerPosts.data.data || [];
      this.totalPages = this.userFollowedTrainerPosts.data.last_page;
    },
  },
};
</script>
